import { createRoute } from "@tanstack/react-router";
import { VersionAssetsPanel } from "@/components/case/version-assets-panel";
import { versionLayoutRoute } from "./version-layout-route";

export const versionAssetsRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/assets",
  component: VersionAssetsPage,
});

function VersionAssetsPage() {
  const { caseId, versionId } = versionAssetsRoute.useParams();
  return <VersionAssetsPanel caseId={caseId} versionId={versionId} />;
}
